<div [ngClass]="fieldCls" [class.card-has-errors]="group?.invalid" [attr.data-hidden]="!fieldVisible">
  <div class="form-group label-container" [attr.data-hidden]="!editMode && !isBlankOrBreak">
    <label [attr.test-id]="descriptor?.zoneID"
           *ngIf="fieldReady && !isBlankOrBreak && descriptor?.type != 'BOOLEAN'">
      {{ descriptor?.transId | translate }}
      <em *ngIf="descriptor.zoneID === 'cliEmp.email'"
          tooltip="{{'EMPLOYEE_HIRE.main_email' | translate}}"
          class="fa-solid fa-circle-info m-r-xs"></em>
      <span class="required" *ngIf="descriptor?.isRequired">*</span>
      <i class="fa fa-light fa-spinner fa-spin"
         attr.mvel-alias="{{descriptor?.defaultValue}}"
         *ngIf="descriptor?.defaultValue"></i>
    </label>

    <!-- actual field injected here -->
    <div [ngClass]="isPrefilledField() || forceCalculate ? 'field-inline' : 'field-block'">
      <i aria-hidden="true"
         *ngIf="(isPrefilledField() || forceCalculate) && !isHeritageRemoved"
         class="fa-light fa-link-simple disabled-fa inherited-icon"
         [tooltip]="descriptor.repInheritedValue ? getRepInheritedTooltip() : (calculationActive ? 'FORMS.auto_calculation_on' : 'FORMS.auto_calculation_off') | translate">
      </i>
      <div class="field-flex-grow"
        [tooltip]="getCalculatedFieldTooltip()"
        triggers="mouseenter:mouseleave"
        placement="bottom">
        <div
          class="fieldFileComponent"
          [class.isFile]="descriptor.type === 'FILE'"
          [class.is-disabled]="isAiOCRLoading">
          <div class="fieldBody">
            <ng-template #fieldComponent></ng-template>
          </div>
          <button
            *ngIf="shouldShowAiIcon()"
            [ngClass]="!isAiOCRLoading ? 'btn fa fa-sparkles generate-with-ai-icon' : 'btn loading-icon'"
            [tooltip]="!isAiOCRLoading ? ('AI_GENERATION.you_can_now_autofill_with_ai' | translate) : ('AI_GENERATION.generating' | translate)"
            type="button"
            [disabled]="isAiOCRLoading"
            test-id="aiUploadBtn"
            (click)="generateWithAiUsingFile(value.file, $event)">
            <span *ngIf="isAiOCRLoading" class="gp-spinner gp-spinner--primary gp-spinner--sm"></span>
          </button>
        </div>
      </div>
        <div *ngIf="isPrefilledField() && !originalDescriptor?.readOnly" (click)="toggleHeritage()" class="erase-prefill">
          <i aria-hidden="true"
             [ngClass]="isHeritageRemoved ? 'fa-arrow-turn-left' : 'fa-pencil'"
             [tooltip]="isHeritageRemoved ? ('FORMS.revert_to_auto' | translate) : ''"
             class="fa-light pointer">
          </i>
        </div>
    </div>

    <gp-form-field-validation
      [control]="control"
      [descriptor]="descriptor"
      [groupZoneType]="groupZoneDescriptor.groupZoneType"
      [fieldData]="cardData"
    >
    </gp-form-field-validation>
  </div>
  <div class="form-group action-label" *ngIf="!editMode && !isBlankOrBreak" (click)="focused = true">
    <small class="text-muted text-ellipsis">
      {{ descriptor?.transId | translate }}
      <em *ngIf="descriptor.zoneID === 'cliEmp.email'"
          tooltip="{{'EMPLOYEE_HIRE.main_email' | translate}}"
          class="fa-solid fa-circle-info m-r-xs"></em>
      <gp-form-field-mapping-indicators *ngIf="!isOnBoarding && employeeId"
                                        [descriptor]="descriptor"></gp-form-field-mapping-indicators>
    </small>
    <div class="_500 text-ellipsis field-value" [attr.test-id]="descriptor?.transId"
         [ngStyle]="{'overflow-x' : (descriptor.type === 'WORK_CYCLE_TABLE') ? 'auto' : null }">
      <i aria-hidden="true"
         *ngIf="isPrefilledField() || forceCalculate"
         class="fa-light fa-link-simple p-r-sm disabled-fa"
         [tooltip]="descriptor.repInheritedValue ? getRepInheritedTooltip() : (calculationActive ? 'FORMS.auto_calculation_on' : 'FORMS.auto_calculation_off') | translate">
      </i>
      <span [class.text-ellipsis]="value.file"
            #tooltip="bs-tooltip"
            [innerHTML]="displayValue"
            [tooltip]="entityPath"
            container="body"></span>
      <ng-container class="file-actions" *ngIf="value.file">
        <i *ngIf="isViewAttachmentsActive() && isSupportedFileType(value.file.filename)"
           class="fa fa-light fa-eye pointer"
           [tooltip]="'TOOLTIPS.view' | translate"
           (click)="viewFile($event)">
        </i>
        <i class="fa fa-light fa-download pointer p-x-sm"
           [tooltip]="'EMPLOYEE_MANAGE.download' | translate"
           *ngIf="!downloading"
           (click)="downloadFile($event)">
        </i>
        <i *ngIf="downloading" class="fa fa-light fa-spinner fa-spin p-x-sm"></i>
      </ng-container>
    </div>
  </div>
</div>
<gp-view-document-side-panel
  *ngIf="showViewDocumentPanel"
  (close)="onCloseSidePanel()"
  [currentFileName]="currentFileName"
  [error]="previewError"
  [noSupportedFormat]="noSupportedFormat"
  [loading]="loadingPreview"
  [preview]="reportDefinitionPreview"
></gp-view-document-side-panel>
